import { Flex, Tag } from '@project44/manifest-ds';
import { useTracking } from '@project44/ui-utils';

import { OpenEntityButton } from '../../components/OpenEntityButton';
import { ChildrenType } from '../../definitions/types/Children';
import { EntityType } from '../../definitions/types/Entity';
import { useWorkspaceActions } from '../../providers/WorkspaceActions';
import { scopedT } from '../../utils/helpers/scopedT';
import { Tooltip } from '../Tooltip';

import { IconsContainer, Item } from './styles';

interface RelatedReferenceItemProps {
  entity: EntityType;
  iconAlert?: ChildrenType;
  status?: JSX.Element | string;
  title: string;
  onTagClick?: () => void;
  entityOpenDisabled?: boolean;
  masterShipmentId: string;
  locationType: LocationTypeEnum;
}

const t = scopedT();

export type LocationTypeEnum = 'default' | 'expanded';

export const RelatedReferenceItem = ({
  entity,
  iconAlert,
  status,
  title,
  onTagClick,
  entityOpenDisabled,
  masterShipmentId,
  locationType,
}: RelatedReferenceItemProps) => {
  const trackEvents = useTracking();
  const {
    state: { entities },
  } = useWorkspaceActions();

  const onAddToWorkspace = () => {
    trackEvents.track({
      eventName: 'MVMT_WORKSPACE_OPEN_ENTITY',
      properties: {
        fromEntityType: 'shipment',
        toEntityType: entity.type,
        fromEntityPosition:
          entities.findIndex((i) => i.id === masterShipmentId) + 1,
        toEntityPosition: entities.length + 1,
        totalWorkspaceEntities: entities.length + 1,
        sourceEntityLocation:
          locationType === 'default'
            ? `related ${entity.type}s`
            : `expanded related ${entity.type}s`,
      },
    });
  };

  return (
    <Item data-testid="related-reference-item">
      <Flex justify="between">
        <Flex align="center">
          <Tooltip
            message={t('copy')}
            messageClicked={t('copied')}
            childrenStyles={{ marginRight: '6px' }}
          >
            <Tag
              style={{ cursor: 'pointer', maxWidth: '400px' }}
              data-testid="related-reference-tag"
              onClick={onTagClick}
            >
              {title}
            </Tag>
          </Tooltip>
          {status}
          <IconsContainer>{iconAlert}</IconsContainer>
        </Flex>
        {!entityOpenDisabled && (
          <OpenEntityButton
            entity={entity}
            onAddToWorkspace={onAddToWorkspace}
          />
        )}
      </Flex>
    </Item>
  );
};
